import React, { useState, useEffect } from "react";

const RoleDropdown = ({
  isDisabled,
  isLoading,
  newUser,
  handleInputChange,
  roleOptions,
}: any) => {
  const [roles, setRoles] = useState<string[]>([]);

  useEffect(() => {
    const fetchRoles = async () => {
      const options = roleOptions;
      setRoles(options);
    };

    fetchRoles();
  }, [roleOptions]);

  const handleOptionClick = (event: React.ChangeEvent<HTMLSelectElement>) => {
    handleInputChange({
      target: { name: "role", value: event.target.value },
    });
  };

  return (
    <div>
      <select
        id="role"
        disabled={isDisabled}
        value={isLoading ? "" : newUser.role}
        onChange={handleOptionClick}
        className="custom-select relative h-10 w-full rounded-md  border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm font-medium text-navy-700 shadow-sm focus:outline-none sm:text-sm"
      >
        {isLoading ? (
          <option value="">Retrieving...</option>
        ) : (
          roles.map((role: string) => (
            <option key={role} value={role}>
              {role}
            </option>
          ))
        )}
      </select>
    </div>
  );
};

export default RoleDropdown;
